export class RepinQtyModel {
spnRepinQty: string;
setValue(res){
if(res){
if(res['spnRepinQty']){this.spnRepinQty = res['spnRepinQty'];}
}
}
}